<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Form Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <b-form @submit.prevent="submitForm">
      <b-row class="mt-4">
        <b-col>
          <h3>Apply Test Package</h3>

          <b-alert variant="info" show>
            <i class="fa fa-info-circle" />
            Analytes are applied to the sample based on the sample's index within the submission. Submission samples are indexed based on the the test package they are initially created from.
            'Individual' test packages do not contain indexed samples and will apply all analytes to all samples regardless of index.

            <br><br>
            Example: Sample/Depth #2 from an SF11 soil submission. SF14 test package is applied to the sample. Only analytes from the SF14 sample #2 definition will be applied.
          </b-alert>

          <div>
            <CustomFormRadioGroup
              :lg="4"
              :md="4"
              :grouped="true"
              :options="test_package_options"
              v-model="form_data.selected_test_package"
            />
          </div>
        </b-col>
      </b-row>

      <!-- validation error -->
      <b-row v-if="invalid" class="mt-4">
        <b-col>
          <b-alert variant="danger" show>
            <i class="fa fa-exclamation-triangle" /> Please review the form and complete all required fields.
          </b-alert>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-button
            type="submit"
            class="my-4 float-right py-3 px-5"
            variant="success"
          >
            <i class="fal fa-save" /> Save
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { getCollection } from '@/shared/fetch-utils'
import Multiselect from 'vue-multiselect'
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import CustomFormRadioGroup from "@/components/shared/form/CustomFormRadioGroup"

export default {
  name: 'SampleApplyTestPackageForm',
  components: {
    Multiselect,
    CustomFormRadioGroup
  },
  mixins: [validationMixin],
  props: {
    sample: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: true,

      form_data: {
        selected_test_package: null
      },

      test_package_collection: null,
      test_package_options: []
    }
  },
  validations: {
    form_data: {
      selected_test_package: { required }
    }
  },
  computed: {
    invalid () {
      return this.$v && this.$v.$dirty && this.$v.$invalid
    }
  },
  created () {
    this.loading = true

    this.init()
  },
  methods: {
    submitForm () {
      this.$v.$touch()
      if (this.invalid) return

      return this.$emit('submit', this.form_data)
    },

    async fetchTestPackages (query) {
      const filters = [
        {
          logic: 'filterEquals',
          field: 'sample_type_id',
          value: this.sample.sample_type_id
        }
      ]

      if (query) {
        filters.push({
          logic: "filterContains",
          field: "name",
          value: query
        })
      }

      this.test_package_collection = await getCollection({
        collection_type: 'test_package',
        message: this.$bvToast,
        connections: [
          'test_package_group'
        ],
        filters,
        limit: "all"
      })

      // unique test package groups by id
      const test_package_groups = _.uniqBy(this.test_package_collection.models.map(({ test_package_group }) => test_package_group), 'id')

      this.test_package_options = test_package_groups.filter((test_package_group) => test_package_group).map((test_package_group) => {
        return {
          text: test_package_group.name,
          options: this.test_package_collection.models.filter(({ test_package_group_id }) => test_package_group_id === test_package_group.id).map((test_package) => {
            return {
              text: test_package.name,
              value: test_package.id,
              icon: 'cube'
            }
          })
        }
      })
    },

    async init () {
      await this.fetchTestPackages()

      this.loading = false
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
